import { useEffect, useState } from 'react'

import { useMetaResponseHandler } from '@/Shared/ui/form'
import { useLoader } from '@/Shared/ui/loader'
import { StoresContract } from '@/Store/application'
import { ContactModel, StoresRepository } from '@/Store/domain'

export interface IUseStoreContactsController {
  storeContacts: ContactModel[]
}

export const useStoreContactsController = (
  repository: StoresRepository,
  id: number,
): IUseStoreContactsController => {
  const { startLoading, stopLoading } = useLoader()

  const [storeContacts, setStoreContacts] = useState<ContactModel[]>([])

  const { handleMetaResponse } = useMetaResponseHandler()

  const loadStoreContacts = async (merchantId: number): Promise<void> => {
    startLoading()

    const response = await StoresContract(repository).getStoreContactsData(merchantId)

    stopLoading()

    if (handleMetaResponse(response?.meta, undefined, { notifySuccess: false })) {
      if (response.data) setStoreContacts(response.data)
    }
  }

  useEffect(() => {
    if (id) loadStoreContacts(id)
  }, [])

  return {
    storeContacts,
  }
}
